module.exports = __webpack_public_path__ + "static/letnie_warsztaty2024_profildance-902e0e7b736bd7552cdf3835b4a0bc6e.pdf";